// Header.js
import styles from './Header.module.css'
import { useLanguage } from '../contexts/LanguageContext'
import getData from './Model'

function Header(){
    const { language } = useLanguage()
    const ui = getData('ui', language)
    
    return (
        <div className={styles.Header}>
            {ui.header}
        </div>
    )
}

export default Header